module.exports = __webpack_public_path__ + "img/3.fbdb2085.png";